import {SET_COMERCIAL_APPROVAL_DATA,SELECT_ROW_COMERCIAL_APPROVAL_RECEIVED,RESET_COMERCIAL_APPROVAL_DATA,UPDATE_ALL_ROW_SELECTION_COMMERCIAL_APPROVAL_ECF} from '../../../../constants/ActionTypes'


const InitialState={
    DataTable:[],
}

function CommercialApproval(state = InitialState, action) {
    switch (action.type) {

        case SET_COMERCIAL_APPROVAL_DATA:
                        return {
                            ...state,
                            DataTable:action.payload.map(x=>({...x, selection: false,approvement:null, rejectionReason:null})) // Initialize selection to false
                        }

        case UPDATE_ALL_ROW_SELECTION_COMMERCIAL_APPROVAL_ECF:  
                        var newData=state.DataTable.map((x)=>({
                            ...x,
                            selection:action.payload
                        }))
        
                        return {
                            ...state,
                            DataTable:newData
                            }
        case SELECT_ROW_COMERCIAL_APPROVAL_RECEIVED:
          var Index = state.DataTable.findIndex(x=>x.id ==action.payload.id );
          let  ListData = state.DataTable;
          ListData[Index].selection =action.payload.selection //ListData[Index].selection;
          ListData[Index].approvement =action.payload?.approvement //ListData[Index].selection;
          ListData[Index].rejectionReason =action.payload?.rejectionReason //ListData[Index].selection;
            return{
                ...state,
                DataTable: ListData

            }

         default:
         return state;    

        case RESET_COMERCIAL_APPROVAL_DATA:
            return {
                ...state,
                DataTable: []   
            }
    }
    
}


export default CommercialApproval;